module.exports = __webpack_public_path__ + "static/3_Visit_2208x1242.9f299b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/3_Visit_2208x1242.png
// module id = 1160
// module chunks = 35783957827783